<template>
  <div v-if="show">
    <el-dialog title="包裹信息" :visible.sync="show" width="1000px">
      <el-table :data="package" show-summary :summary-method="getSummaries">
        <el-table-column property="express_no" label="单号"></el-table-column>
        <el-table-column property="shelves_id" label="货架号" ></el-table-column>
        <el-table-column property="uid" label="会员号"></el-table-column>
        <el-table-column property="total_price" label="货值">
          <template slot-scope="scope">
            ${{(scope.row.total_price / 100).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column property="total_weight" label="重量">
          <template slot-scope="scope">
            {{(scope.row.total_weight / 100).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column property="volume" label="体积">
          <template slot-scope="scope">
            {{(scope.row.volume / 1000).toFixed(3)}}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="操作" width="50" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="canRefund" type="danger" icon="el-icon-close" circle size="mini" @click="refundPackage(scope.row.uid,scope.row.id,scope.row.group_id)" ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "GroupPackageItems",
  data() {
    return {
      id:'',
      show:false,
      package:[],
      canRefund:false
    }
  },
  methods:{
    open(id,refund){
      this.id = id
      this.canRefund = refund || false
      this.getPackage()
    },
    getPackage(){
      this.package = []
      this.$fetch.post('Package/getGroupPackage', {
        id: this.id
      }, true).then(res => {
        this.show = true
        this.package = res
      })
    },
    refundPackage(uid,id,groupId){
      this.$fetch.post('Group/refundGroupPackage', {
        id: id,
        groupId,
        targetUid:uid
      }, true).then(res => {
        this.$message({
          type: 'success',
          message: '退出成功'
        });
        this.getPackage()
        this.$emit("refund")
      })

    },
    getSummaries(param) {
      if(!param){
        return
      }
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index <= 2 && index > 0) {
          sums[index] = '';
          return;
        }
        if (index === 6) {
          sums[index] = '';
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return  prev;
            }
          }, 0);
          sums[index] = index === 5 ? (sums[index] / 1000).toFixed(3):(sums[index] / 100).toFixed(2) ;
        }
      });

      return sums;
    }
  }
}
</script>

<style scoped>

</style>
